// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { func, string } from 'prop-types'

const CloseSearch = ({ closeModal, idRoot }) => (
  closeModal
    ? (
      <p
        id={`${idRoot}modal-heading-close`}
        className={'pointer'}
        onClick={closeModal}>
        {'X'}
      </p>
    ) : null
)

CloseSearch.propTypes = {
  closeModal: func,
  idRoot: string.isRequired,
}

export default CloseSearch
